import {
  HIRING_AUTHORITY_DRAWERS,
  HIRING_AUTHORITY_PROFILE_CONFIG
} from 'features/inventory-profiles/constants';
import { buildOptOutDetail, buildRecruiterDetail } from 'features/inventory-profiles/utils';
import strings from 'strings';

const COPIES = strings.inventoryProfiles;

export const formatHiringAuthorityResponse = hiringAuthority => ({
  header: {
    entityType: HIRING_AUTHORITY_PROFILE_CONFIG.type,
    title: hiringAuthority.full_name,
    lastActivity: hiringAuthority.lastActivityLog?.created_at
  },
  summary: {
    company: { id: hiringAuthority.company?.id, name: hiringAuthority.company?.name },
    location: null,
    created: {
      date: hiringAuthority.created_at,
      by: hiringAuthority.createdBy?.personalInformation?.full_name
    },
    details: [buildRecruiterDetail(hiringAuthority.recruiter), buildOptOutDetail(hiringAuthority)]
  },
  status: {
    itemStatus: hiringAuthority.status,
    subStatus: hiringAuthority.subStatus,
    optOutStatus: hiringAuthority.optOutStatus,
    emailValidationStatus: hiringAuthority.emailValidation?.verdict?.name,
    otherEmailValidationStatus: hiringAuthority.personalEmailValidation?.verdict?.name,
    entityTypeId: HIRING_AUTHORITY_PROFILE_CONFIG.id
  }
});

export const buildHiringAuthorityMenuItems = ({
  onAddCandidate,
  onUnlinkCandidate,
  openDrawer,
  permissions,
  restrictionMenuItems,
  searchProjectMenuItems
}) => [
  {
    title: COPIES.common.editProfile,
    action: openDrawer(HIRING_AUTHORITY_DRAWERS.Edit),
    visible: permissions.canEdit
  },
  ...searchProjectMenuItems,
  {
    title: COPIES.common.candidateAddition,
    action: onAddCandidate,
    visible: !permissions.hasCandidate
  },
  {
    title: COPIES.menu.linkCandidate,
    action: openDrawer(HIRING_AUTHORITY_DRAWERS.LinkCandidate),
    visible: !permissions.hasCandidate
  },
  {
    title: COPIES.menu.unlinkCandidate,
    action: onUnlinkCandidate,
    visible: permissions.hasCandidate
  },
  {
    title: COPIES.menu.addAction,
    action: openDrawer(HIRING_AUTHORITY_DRAWERS.Task),
    visible: permissions.canUseDailyPlan
  },
  ...restrictionMenuItems
];
